import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'
import { Icon } from 'common-components'

export const DropdownListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  ${customizeVerticalScrollbarThumbMixin()}
`

export const ModelItemWrapper = styled.div<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  padding: 10px 8px;
  border-radius: 4px;
  border: ${({ $isSelected }) =>
    $isSelected && `1px solid ${COLORS.borderColor}`};
  cursor: pointer;
  transition: background-color 0.2s;
  background-color: ${({ $isSelected }) =>
    $isSelected ? COLORS.primaryExtraLight : 'transparent'};

  &:hover {
    background-color: ${COLORS.primaryExtraLight};
  }
`

export const CrownBadgeIcon = styled(Icon)`
  display: inline-flex;
  margin-top: -1px;
`

export const ModelTextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`

export const ModelNameWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
`

export const CreditsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 6px;
`

export const ModelVolumeIconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`

export const VolumeIconBox = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${COLORS.secondary};

  & > svg {
    fill: ${COLORS.secondarySemiDark};
  }

  &:hover {
    background: ${COLORS.primaryLight};

    & > svg {
      fill: ${COLORS.secondaryDark};
    }
  }
`

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const BetaBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 4px;
  background-color: ${COLORS.primaryDark};
`

export const RenderforestGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid ${COLORS.borderColor};
  overflow: hidden;

  ${ModelItemWrapper} {
    border: none;
    border-radius: 0;
  }

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    overflow: visible;
  }
`

export const UnlimitedBannerWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-radius: 4px;
  margin-top: 4px;
  background: linear-gradient(135deg, #5b4bc4 0%, #7b6de0 100%);
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`

export const UnlimitedBannerText = styled.span`
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: ${COLORS.white};
`

export const UnlimitedHighlight = styled.span`
  color: #ffc107;
  font-weight: 700;
`
